import React, { useState, useEffect } from "react";
import { Snackbar, IconButton, Alert, Tooltip } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useGridApiRef } from '@mui/x-data-grid-pro';
import ControlledDataGrid from '../../../components/DataGrid/ControlledDataGrid';
import { DataGridPro } from '@mui/x-data-grid-pro';
import ClearIcon from '@mui/icons-material/Clear';
import moment from "moment";
import axios from "axios";
import { APIURL } from "../../../config";

export default function MTSummaryReport(props) {
    const [gridId, setGridId] = useState(57);
    const apiRef = useGridApiRef();

    const [isLoading, setIsLoading] = useState(true);
    const [data, setData] = useState([]);
    const [reportDetails, setReportDetails] = useState({});
    const [isFavorite, setIsFavorite] = useState(false);
    const [successText, setSuccessText] = useState("");
    const [errorText, setErrorText] = useState("");

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        axios
            .get(APIURL + "/jsreport/getAllReports", {
                params: { empID: props.user.emp_id },
            })
            .then((response) => {
                const report = response?.data?.reports.find((ele) => ele.report_name === "MT Summary Report");
                setReportDetails(report);
                setIsFavorite(report ? (report.status === 1 ? true : false) : false);
            });

        axios
            .get(APIURL + "/reports/getMTSummary", {
                params: { com_id: props.user.comp_id, emp_id: props.user.emp_id },
            })
            .then((response) => {
                setData(response?.data.length !== 0 ? response?.data : []);
                setIsLoading(false);
            })
            .catch((err) => {
                console.log(err);
                setIsLoading(false);
            });
    };

    // The month cells hold an array of MT entries. CSV/Excel export ignores renderCell and
    // serializes the raw cell value, so a valueGetter is needed to export readable text.
    const monthColumns = Array.from({ length: 12 }, (_, offset) => {
        const field = offset === 0 ? "current_month" : `previous_${offset}_month`;

        return {
            field,
            headerName: moment().subtract(offset, "month").startOf("month").format("MMM YYYY"),
            width: 130,
            valueGetter: (value) => {
                if (!value || value.length === 0) return "";
                const date = value[0].created_on ? moment(value[0].created_on).format('MM-DD-YYYY') : "";
                return [date, value[0].mt_type].filter(Boolean).join(" ");
            },
            renderCell: (params) => {
                const entries = params.row[field];
                if (entries && entries.length !== 0) {
                    return (
                        <div className="d-flex flex-row align-items-center" >
                            {<div className="mtDate">
                                {moment(entries[0].created_on).format('MM-DD-YYYY')}
                            </div>}
                            {<div className="mtTypeIcon">
                                {entries[0].mt_type?.[0]}
                            </div>}
                        </div >
                    );
                }
                else {
                    return (
                        <div className="mtClearIcon">
                            <ClearIcon />
                        </div>
                    );
                }
            }
        };
    });

    const columns = [
        { field: "cus_id", headerName: "Customer ID", hide: true },
        { field: "cus_name", headerName: "Customer Name", width: 200 },
        { field: "sc_name", headerName: "Support Coordinator", width: 200 },
        ...monthColumns,
    ];

    let rows = data.map((data, idx) => {
        let taskData = {
            rowID: idx,
            cus_id: data.cus_id,
            cus_name: data.cus_name,
            sc_name: data.SCName ? data.SCName.map((emp) => emp.emp_first_name + ' ' + emp.emp_last_name).join(', ') : '',
            current_month: data.MTData[moment().format("MMM YYYY")],
            previous_1_month: data.MTData[moment().subtract(1, "month").format("MMM YYYY")],
            previous_2_month: data.MTData[moment().subtract(2, "month").format("MMM YYYY")],
            previous_3_month: data.MTData[moment().subtract(3, "month").format("MMM YYYY")],
            previous_4_month: data.MTData[moment().subtract(4, "month").format("MMM YYYY")],
            previous_5_month: data.MTData[moment().subtract(5, "month").format("MMM YYYY")],
            previous_6_month: data.MTData[moment().subtract(6, "month").format("MMM YYYY")],
            previous_7_month: data.MTData[moment().subtract(7, "month").format("MMM YYYY")],
            previous_8_month: data.MTData[moment().subtract(8, "month").format("MMM YYYY")],
            previous_9_month: data.MTData[moment().subtract(9, "month").format("MMM YYYY")],
            previous_10_month: data.MTData[moment().subtract(10, "month").format("MMM YYYY")],
            previous_11_month: data.MTData[moment().subtract(11, "month").format("MMM YYYY")],
        };
        return taskData;
    });

    const markFavourite = async (data, type) => {
        const payload = {
            report_id: data?.report_id,
            status: type,
            empID: props.user.emp_id
        };

        axios
            .put(APIURL + "/jsreport/markFavorite", payload)
            .then((response) => {
                if (response?.status === 200 && response?.data?.code === 200) {
                    setSuccessText(response?.data?.status_message || "Favorite Modifed Succesfully");
                } else {
                    setErrorText("Something went wrong");
                }

                fetchData();
            });
    }

    return (
        (<div style={{ width: '100%', padding: 10 }}>
            <div>
                {props.source !== 'Home' &&
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <div />
                        <Tooltip title={isFavorite ? "Remove from favorite reports" : "Add to favorite reports"}>
                            <img
                                src={isFavorite ? "./star-solid.svg" : "./star-regular.svg"}
                                alt="barchart"
                                style={{
                                    fontFamily: "Lato",
                                    width: "1.5rem",
                                    height: "1.5rem",
                                    cursor: "pointer",
                                    margin: 5
                                }}
                                onClick={() => markFavourite(reportDetails, isFavorite ? 0 : 1)}
                            />
                        </Tooltip>
                    </div>
                }
                <div style={{ height: 'calc(100vh - 235px)' }}>
                    <ControlledDataGrid
                        gridId={gridId}
                        user={props.user}
                        initialState={{ sorting: { sortModel: [{ field: "cus_name", sort: "asc" }] } }}
                        apiRef={apiRef}
                        getRowId={(row) => row.rowID}
                        rows={rows}
                        columns={columns}
                        checkboxSelection={false}
                        disableRowSelectionOnClick
                        loading={isLoading}
                    />
                </div>
            </div>
            <Snackbar
                open={successText !== ""}
                autoHideDuration={30000}
                onClose={() => setSuccessText("")}
            >
                <Alert
                    sx={{ width: "100%" }}
                    severity={"success"}
                    elevation={6}
                    variant="filled"
                >
                    {successText}
                    <IconButton
                        aria-label="close"
                        color="inherit"
                        sx={{ p: 0.25 }}
                        onClick={() => setSuccessText("")}
                    >
                        <CloseIcon />
                    </IconButton>
                </Alert>
            </Snackbar>
            <Snackbar
                open={errorText !== ""}
                autoHideDuration={30000}
                onClose={() => setErrorText("")}
            >
                <Alert
                    sx={{ width: "100%" }}
                    severity={"error"}
                    elevation={6}
                    variant="filled"
                >
                    {errorText}
                    <IconButton
                        aria-label="close"
                        color="inherit"
                        sx={{ p: 0.25 }}
                        onClick={() => setErrorText("")}
                    >
                        <CloseIcon />
                    </IconButton>
                </Alert>
            </Snackbar>
        </div>)
    );
};